import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject, Subscription, timer} from 'rxjs';
import {AuthService} from '../../../services/auth.service';
import {delay, finalize, repeat, takeUntil, tap} from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
import {TokenService} from '../../../token.service';
import {Router} from '@angular/router';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {CompanySwitcher} from '../../../portal/header/company-switcher.service';
import { CryptoStorageService } from '@services/storage-service.service';

@Component({
  selector: 'app-qr-login',
  templateUrl: './qr-login.component.html',
  styleUrls: ['./qr-login.component.scss']
})
export class QrLoginComponent implements OnInit, OnDestroy {
  @Input() disableLoginRedirect?: boolean;
  @Input() relogin = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  loadingNewQr: boolean;
  companyList = [];
  selectedCompany = null;
  isTooltipShown: boolean;
  bgQr = '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';
  qrData = 'HelloDar';
  showRefreshBtn: boolean;
  expireTimeInSeconds = 300;
  isLoading = false;
  timer = this.expireTimeInSeconds;
  deviceCode: string;
  timerCountDown: Subscription;

  constructor(
    private authService: AuthService,
    private router: Router,
    private companySwitcher: CompanySwitcher,
    private message: NzNotificationService,
    private tokenService: TokenService,
    private cryptoStorageService: CryptoStorageService
  ) {
  }

  ngOnInit(): void {
    this.getQrCode();
    this.timerCountDown = timer(0, 1000).subscribe(() => {
      if (!this.timer) {
        this.getQrCode();
      }
      --this.timer;
    });
  }

  getQrCode(): void {
    this.loadingNewQr = true;
    this.authService.getQrCode().subscribe(res => {
      const {user_code, device_code, expires_in} = res.body;
      this.qrData = 'A:' + user_code;
      this.deviceCode = device_code;
      this.timer = expires_in;
      this.loadingNewQr = false;
      this.checkQrAuth();
    });
  }

  checkQrAuth(): void {
    this.authService.getQrAuthStatus(this.deviceCode).subscribe(res => {
      const {status, device_code, username} = res.body;
      switch (status) {
        case 'PENDING':
          this.checkQrAuth();
          break;
        case 'READY':
          this.loginQrByDevice(device_code, username);
          break;
      }
    }, err => {
      if (err.error.message === 'TOKEN_EXPIRED') {
        this.getQrCode();
      }
    });
  }

  loginQrByDevice(deviceCode: string, username: string): void {
    this.authService.loginQrByDevice(deviceCode, username)
      .pipe(
        tap(() => this.isLoading = true),
        finalize(() => this.isLoading = false)
      )
      .subscribe((token) => {
          this.tokenService.setToken(token);
          const parsedJWT = jwt_decode<any>(token.access_token);
          const companyIdWithQr = parsedJWT.provider_parameters['sib-current-company'];
          if (parsedJWT?.preferred_username) {
            this.cryptoStorageService.setToSessionStorage('A_DATA', { phoneNumber: parsedJWT.preferred_username });
          }
          this.authService.getCompanysByQr(token.access_token).subscribe(res => {
            localStorage.setItem('AUTH_METHOD', 'qr');
            const {companies, lastname, firstname, middlename} = res.body;
            if (res.ok) {
              this.companyList = companies && companies.length > 0 ? companies : [];
              this.cryptoStorageService.setToSessionStorage('U_COMPANIES', this.companyList);
              if (companyIdWithQr) {
                const companyFromQr = this.companyList && this.companyList.length > 0 && this.companyList.find((el: any) =>
                  el.pcustomer === companyIdWithQr
                );
                this.companySwitcher.setSelectedCompany(companyFromQr);
                this.selectedCompany = companyFromQr;
              } else {
                this.selectedCompany = this.companyList && this.companyList.length > 0 ? this.companyList[0].pcustomer : null;
              }

              this.cryptoStorageService.setToSessionStorage('U_COMPANIES', this.companyList);
              localStorage.setItem('USER_NAME', `${lastname} ${firstname} ${middlename}`);
              if (this.disableLoginRedirect) {
                // on idle modal
                window.location.reload();
              } else {
                this.router.navigate(['portal/main']);
              }
            } else {
              this.message.error('Ошибка авторизации', 'Проверьте логин или пароль');
            }
            this.isLoading = false;
          }, err => {
            this.isLoading = false;
          });
        },
        error => {
        });
  }

  ngOnDestroy(): void {
    this.timerCountDown.unsubscribe();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
